
import "./lib/class-component-hooks";
import Vue from "vue";
import App from "./App.vue";
import Store from "./store";
import { router } from "./router";


// Vue Configs
// -------------------------------------------------------------------------

Vue.config.productionTip = false;
// Vue.config.warnHandler = (msg, vm, trace) => {
//     // `trace` is the component hierarchy trace
// };

window.store = Store;


// Global Configs
// -------------------------------------------------------------------------

window.offset = (el: HTMLElement) => {
    const rect: ClientRect = el.getBoundingClientRect();
    const scrollLeft: number = window.pageXOffset || document.documentElement.scrollLeft;
    const scrollTop: number = window.pageYOffset || document.documentElement.scrollTop;

    return {
        top: rect.top + scrollTop,
        left: rect.left + scrollLeft,
    };
};

window.consoleTime = Date.now();


// Build
// -------------------------------------------------------------------------

new Vue({
    router,
    render: (h) => h(App),
}).$mount("#Main");
